import { isWeb } from "@stepapp/core";
import { palette, spacing } from "@stepapp/ui";
import { Slot, Stack } from "expo-router";
import { StyleSheet } from "react-native";

const ReviewLayout = () => {
  
  return (
    <>
      {isWeb ? (
        <Slot />
      ) : (
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: styles.content,
          }}
        />
      )}
    </>
  );
};

export default ReviewLayout;

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: spacing.unit * 2.5,
    backgroundColor: palette.common.white,
  },
});
